
import Env from '../base/env'
import Channels from '../base/channels'
import {TweenLite} from 'gsap';

class Launcher
{
    constructor()
    {
        if(Env.$launcher == null) return false
        // Dom
        this.view = Env.$launcher
        this.$fill = this.view.querySelector('.fill')
        this.$fillOut = this.view.querySelector('.fill-outside')
        this.$logoFull = this.view.querySelector('.logo-full')
        this.$logoPartial = this.view.querySelector('.logo-partial')
        this.$pattern = this.view.querySelector('.bg')
        this.$shape = this.view.querySelector('.shape')
        // Vars
        this.viewport = Env.framework.toolbox.getViewport()
        // Tweens
        this.tlIn = new TimelineLite()
        this.tlOut = new TimelineLite()
        // Preload
        this.imgsToPreload = []
        // Flags
        this.TOTAL_PRELOAD = this.imgsToPreload.length
        this.NO_INTRO = false
        this.LAUNCHED = false
        this.SPEED = 5
        if(Env.mobileCSS == true) {
            this.NO_INTRO = true
        }
        // FNs
        this.setup()
    }


    completeIn()
    {
        setTimeout(() => {
            this.out()
        }, 600);
    }

    completeOut()
    {
        Env.$html.classList.add('ui--isReady')
        this.LAUNCHED = true
        Env.$master.removeChild(this.view)
    }

    destroy()
    {

    }

    noLaunch()
    {
        Env.$master.removeChild(this.view)
        setTimeout(() => {
            Env.$html.classList.add('ui--isReady')
            Channels.emit('launcher::exit')
            this.LAUNCHED = true
        }, 1000);
    }

    out()
    {

        const getCurrentController = Env.framework.toolbox.getController()
        this.tlOut = new TimelineLite()

        this.tlOut.add([
            TweenLite.fromTo(this.$logoPartial , 1 , { opacity : 0 , y : 30 } , { opacity : 1 , y : 0 , ease : Cubic.easeOut }),
        ])
        this.tlOut.add([
            TweenLite.fromTo(this.$shape , 2.5 , { autoAlpha : 1 ,  x : '100%' } , { x : '-100%' , ease : Circ.easeInOut })
        ],'-=.7')
        this.tlOut.add([
            TweenLite.fromTo(this.$logoPartial , .1 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeIn }),
            TweenLite.fromTo(this.$logoFull , .1 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut , immediateRender : false })
        ],'-=1.1')
        if(getCurrentController !== 'home') {
            this.tlOut.add([
                TweenLite.fromTo(this.$logoFull , .6 , { opacity : 1 , y : 0 } , { opacity : 0 , y : -30 , ease : Cubic.easeOut , immediateRender : false })
            ])
            this.tlOut.add([
                TweenLite.fromTo(this.view , .4 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeOut , onStart: ()=>{
                        setTimeout(() => {
                            Channels.emit('launcher::exit')
                        }, 0);
                        setTimeout(() => {
                            Env.$html.classList.add('ui--isReady')
                        }, 200);
                    }
                })
            ])
            this.tlOut.add(()=>{
                this.completeOut()
            })
        } else {
            this.tlOut.add([
                TweenLite.fromTo([this.$fill,this.$fillOut] , .2 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeOut , immediateRender : false , onStart: ()=>{
                        setTimeout(() => {
                            Channels.emit('launcher::exit')
                        }, 200);
                        setTimeout(() => {
                            Env.$html.classList.add('ui--isReady')
                        }, 400);
                    }
                })
            ])
            this.tlOut.add(()=>{
                this.completeOut()
            },'+=1')
        }
    }

    preload()
    {
        var array = Object.values(manifestImg)
        // Create Img
        for(let i = 0; i < array.length; i++) {
            const img = document.createElement('img')
            img.setAttribute('src',array[i])
            this.imgsToPreload.push(img)
        }
    }

    setup()
    {
        Env.framework.toolbox.resetScroll()
        // this.preload()
        if(this.NO_INTRO) {
            this.noLaunch()
        } else {
            setTimeout(() => {
                this.out()
            }, 200);

        }
    }

}

export default Launcher;


// WEBPACK FOOTER //
// ./resources/js/view/launcher.js